function changeConfigurationObj(originalObj, newObj, key) {
  if (!originalObj || !newObj || !key) {
    throw new Error('Please provide all arguemens');
  }
  return { ...originalObj, [key]: { ...originalObj[key], ...newObj } };
}
export default changeConfigurationObj;
